import { render, staticRenderFns } from "./SupplierAddressSelect.vue?vue&type=template&id=4d22e4b0"
import script from "./SupplierAddressSelect.vue?vue&type=script&lang=js"
export * from "./SupplierAddressSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports